<template>
  <v-select
    :items="items"
    filled
    :data-cy="dataCy"
    :label="label"
    v-model="localValue"
  />
</template>

<script>
export default {
  name: 'BoolField',
  props: {
    dataCy: {
      type: String,
      default: 'BoolField',
    },
    /**
     * Set the text box label. Default: undefined,
     */
    label: {
      type: String,
      default: undefined,
    },
    /**
     * Set the text box value. Default: undefined,
     */
    value: {
      type: Boolean,
      default: undefined,
    },
  },
  data() {
    return {
      localValue: undefined,
    };
  },
  computed: {
    items() {
      return [{
        text: 'Yes',
        value: true,
      }, {
        text: 'No',
        value: false,
      },
      ];
    },
  },
  watch: {
    value() {
      this.localValue = this.value;
    },
    localValue() {
      this.$emit('input', this.localValue);
    },
  },
  created() {
    this.localValue = this.value;
  },
};
</script>
